import styled from "styled-components";
import { Menu } from "antd";

export const SideBarMenu = styled(Menu)`
  &.ant-menu {
    padding: 0 !important;
  }

  .ant-menu-item {
    padding-left: 24px;
    display: flex;
    align-items: center;
  }

  .ant-menu-item-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 40px;
  }

  .ant-menu-item.custom-settings-item {
    padding-left: 20px !important;
  }

  .ant-menu-item-selected.custom-settings-item {
    padding-left: 20px !important;
  }
`;

export const PrimarySideBarWrapper = styled.div`
  width: 56px;
  height: 100vh;
  background: #ffff;
  padding: 8px 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  z-index: 1001;
  border-right: 1px solid #F3F4F7;
  
  .ant-layout-sider {
    width: 66px !important;
    min-width: 66px !important;
    background: transparent;
    padding: 24px 0px;
  }
  .ant-menu-item {
    padding: 6px;
    gap: 16px;
  }
`;
export const ProfileIcon = styled.div`
  width: 36px;
  height: 36px;
  background-color: #5a6c87;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  border-radius: 50%;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.15s ease;
  text-transform: uppercase;

  &:hover {
    background-color: #47566e;
  }

  &:focus-visible {
    outline: 2px solid #0c53bb;
    outline-offset: 2px;
  }
`;

export const ProfilePopoverContent = styled.div`
  width: 260px;
  padding: 4px 2px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ProfilePopoverHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ProfilePopoverAvatar = styled.div`
  width: 40px;
  height: 40px;
  background-color: #5a6c87;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  border-radius: 50%;
  flex-shrink: 0;
  text-transform: uppercase;
`;

export const ProfilePopoverIdentity = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
`;

export const ProfileName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #1d2f50;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ProfileEmail = styled.div`
  font-size: 12px;
  color: #48566b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ProfileRoleBadge = styled.span`
  display: inline-block;
  align-self: flex-start;
  padding: 2px 8px;
  margin-top: 4px;
  font-size: 11px;
  font-weight: 600;
  color: #0c53bb;
  background: #eaf1fc;
  border-radius: 10px;
`;

export const ProfileDivider = styled.hr`
  border: none;
  border-top: 1px solid #f0f2f5;
  margin: 0;
`;

export const ProfileMeta = styled.div`
  font-size: 11px;
  color: #7a879d;
`;

export const ProfileActionButton = styled.button`
  background: transparent;
  border: 1px solid #e2e6ed;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 500;
  color: #1d2f50;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: #f6f8fa;
    border-color: #c3d5f1;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;
export const ImgWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22px;
`;

/**
 * Stacks the WHG mark and the "Docs" wordmark vertically so the
 * product name fits the 56px sidebar (per Matthew's 2026-08-11
 * branding request: "WHG Docs", stacked for the narrow column).
 */
export const LogoLockup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
`;

export const LogoWordmark = styled.span`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1;
  color: #1d2f50;
  user-select: none;
`;
export const HorizondalLine = styled.hr`
  border: 1px solid #f3f4f7;
  width: 100%;
  margin-bottom: 7px;
  margin-top: 0px;
`;
export const MenuItemClone = styled.div`
  width: 100%;
  padding: 10px 0;
  display: flex;
  justify-content: ${(props) => (props.collapsed ? "center" : "flex-start")};
  align-items: center;
  cursor: pointer;
  transition: background 0.3s;
  padding-left: 20px;

  svg {
    color: #1d2f50;
    font-size: 24px;
  }

  span {
    color: #1d2f50;
    font-size: 14px;
  }

  &:hover {
    background-color: #f0f2f5;
  }

  &.selected {
    background-color: #e6f7ff;
  }
`;
export const BottomWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-contents: center;
  align-items: center;
  padding-bottom: 16px;
  margin-top: auto;
  .ant-layout-sider {
    flex: 0 !important;
    padding-bottom: 8px;
  }
`;

/**
 * Notification-style badge that overlays a sidebar icon.
 *
 * Used by the Inbox nav entry to surface the unread count from
 * `GET /api/inbox/unread-count/`. Caps at "99+" so the bubble
 * doesn't get wider than the icon ring under heavy load.
 *
 * Sized for the 24px Phosphor icon used elsewhere in the sidebar
 * (Tray, House, etc.). The parent <span> is set to `position:
 * relative` at the call site so the absolute positioning here
 * anchors to the icon, not to the menu-item button.
 */
export const SidebarBadge = styled.span`
  position: absolute;
  top: -4px;
  right: -8px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 9999px;
  background: #c8201a;
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  line-height: 16px;
  text-align: center;
  box-sizing: border-box;
  border: 1.5px solid #ffffff;
  pointer-events: none;
  user-select: none;
`;

export const StyledSidebarMenu = styled.div`
  display: flex;
  justify-content: center;
  .ant-menu {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: fit-content;
    border-inline-end: none !important;
  }

  .ant-menu-item {
    padding: 0 !important;
    justify-content: center;
    width: 36px;
    height: 36px;
    flex-shrink: 0;
    .ant-menu-title-content:empty {
      width: 0 !important;
      padding: 0 !important;
      margin: 0 !important;
      overflow: hidden;
      display: none;
    }
  }

  .ant-menu-item-selected {
    border: 1px solid #c3d5f1;
    background: #f1f6fe;
    border-radius: 6px;
  }
`;
